export default {
    DEFAULT_TEXT: {
        0: '请输入/粘贴文本',
        1: '请输入/粘贴文本',
        2: 'Please enter text',
        5: 'Please enter text'
    },

    SWIPER_SLIDE_TYPE: {
        IMG: 'img',
        VIDEO: 'video'
    },

    LAYOUT_TYPE: {
        SWIPER_LEFT: 'swiper-left',
        SWIPER_RIGHT: 'swiper-right'
    },

    DEFAULT_IMG: 'https://static.futunn.com/upload/01fego/default-img-f97c894d4f918a444bfc3a882b368dac.png',

    BASIC_VIDEO: 'basic-video'
};
